export const BLANK_FUND_ID = "__BLANK__"

export const WEEK_DAY_LABELS = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
} as const satisfies Record<number, string>

// Intentionally 1-28
export const MONTH_DAY_LABELS = {
  1: "1st",
  2: "2nd",
  3: "3rd",
  4: "4th",
  5: "5th",
  6: "6th",
  7: "7th",
  8: "8th",
  9: "9th",
  10: "10th",
  11: "11th",
  12: "12th",
  13: "13th",
  14: "14th",
  15: "15th",
  16: "16th",
  17: "17th",
  18: "18th",
  19: "19th",
  20: "20th",
  21: "21st",
  22: "22nd",
  23: "23rd",
  24: "24th",
  25: "25th",
  26: "26th",
  27: "27th",
  28: "28th",
} as const satisfies Record<number, string>

export const TWICE_MONTHLY_LABELS = {
  "1-15": "1st & 15th",
  "6-20": "6th & 20th",
  "11-25": "11th & 25th",
} as const

export const FREQUENCY_TYPE_TO_LABELS = {
  once: "Once",
  monthly: "Monthly",
  weekly: "Weekly",
  every_other_week: "Every other week",
  twice_monthly: "Twice monthly",
} as const
